export class CountryModel {
  currentCountry: string = "Myanmar"
  countryCode: string = "MM"
  countries: any = [ { name: "Afghanistan", dial_code: "+93", code: "AF" } ]
}
